<template>
  <path
    d="M18 9.00022C17.44 9.00022 17 9.45021 17 10.0002V15.5902L6.11998 4.70021C5.72998 4.31021 5.09998 4.31021 4.70998 4.70021C4.31998 5.09021 4.31998 5.72022 4.70998 6.11022L15.59 17.0002H9.99998C9.44998 17.0002 8.99998 17.4502 8.99998 18.0002C8.99998 18.5502 9.44998 19.0002 9.99998 19.0002H18C18.55 19.0002 19 18.5502 19 18.0002V10.0002C19 9.45021 18.55 9.00022 18 9.00022Z"
  />
</template>
